import axios from 'axios';
export const LOAD_CLIENT_DATA = 'load_client_data';
export const SET_LAST_NAME_FILTER = 'set_last_name_filter';
export const SET_EDIT_CLIENT = 'set_edit_client';
export const SET_ADD_CLIENT = 'set_add_client';
export const SET_EDIT_MODE = 'set_edit_mode';
export const SET_REPORT_CLIENT = 'set_report_client';
export const SET_SORT = 'set_sort';


export function loadClientData() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: getState().params.apiURL + '/clients/',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      params: {
        advisorEmail: getState().params.advisorEmail,
        lastName: getState().advisorData.lastNameFilter,
        limit: 100,
      },
    };
    return axios(request)
      .then((response) => {
        dispatch({ type: LOAD_CLIENT_DATA, payload: response.data });
        if(response.data.length === 0) {
          dispatch(setAddClient(true));
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function loadClientDataExcel() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      responseType: 'blob',
      params: {
        advisorEmail: getState().params.advisorEmail,
        },
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      url: getState().params.apiURL + '/clients/export_excel',
    };
    return axios(request)
      .then((response) => {
        const blob = new Blob([response.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
        const a = document.createElement('a');
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = 'ClientDetails.xlsx';
        a.click();
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function addClient(client) {
  return (dispatch, getState) => {
    client.advisorEmail = getState().params.advisorEmail;
    client.advisorFirstName = getState().params.advisorFirstName;
    client.advisorLastName = getState().params.advisorLastName;
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      url: getState().params.apiURL + '/clients/',
      data: client,
    };
    return axios(request)
      .then(() => {
        dispatch(loadClientData());
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function setLastNameFilter(lastName) {
  return (dispatch) => {
    dispatch({ type: SET_LAST_NAME_FILTER, payload: lastName });
    dispatch(loadClientData());
  };
}

export function setEditClient(client) {
  return (dispatch) => {
    dispatch({ type: SET_EDIT_CLIENT, payload: client });
  };
}

export function setAddClient(value) {
  return (dispatch) => {
    dispatch({ type: SET_ADD_CLIENT, payload: value });
  };
}

export function setEditMode(mode) {
  return (dispatch) => {
    dispatch({ type: SET_EDIT_MODE, payload: mode });
  };
}

export function setReportClient(clientID) {
  if(clientID) {
    return (dispatch, getState) => {
      const request = {
        method: 'GET',
        headers: {
          Authorization: 'Token ' + getState().params.token,
        },
        url: `${getState().params.apiURL}/clients/${clientID}/`,
      };
      return axios(request)
        .then((response) => {
          dispatch({ type: SET_REPORT_CLIENT, payload: response.data });
        })
        .catch((error) => {
          console.log(error);
        });
    };
  } else {
    return (dispatch) => {
      dispatch({ type: SET_REPORT_CLIENT, payload: null });
    };
  }
}

export function saveClient(client) {
  client.isDirty = true;
  delete client['fullTermModels'];
  return (dispatch, getState) => {
    const request = {
      method: 'PUT',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      url: `${getState().params.apiURL}/clients/${client.id}/`,
      data: client,
    };
    return axios(request)
      .then(() => {
        dispatch(loadClientData());
        dispatch(setEditClient(client));
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function selectModels(client) {
  return (dispatch, getState) => {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      url: `${getState().params.apiURL}/clients/${client.id}/models/`,
    };
    return axios(request)
      .then((response) => {
        dispatch(loadClientData());
        dispatch(setEditClient(response.data));
        console.log(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function deleteClient(client) {
  return (dispatch, getState) => {
    const request = {
      method: 'DELETE',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      url: `${getState().params.apiURL}/clients/${client.id}/`,
    };
    return axios(request)
      .then(() => {
        dispatch(loadClientData());
        dispatch(setEditClient(null));
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function logEmail(client) {
  return (dispatch, getState) => {
    const request = {
      method: 'POST',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      url: `${getState().params.apiURL}/clients/${client.id}/log_email/`,
    };
    return axios(request)
      .then(() => {
        dispatch(loadClientData());
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function openGPReportPDF(clientID, clientName) {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      url: `${getState().params.apiURL}/clients/${clientID}/report_gp/`,
      responseType: 'blob',
    };
    return axios(request)
      .then((response) => {
        const blob = new Blob([response.data], {type: 'application/pdf'});
        const a = document.getElementById('gp-report-download');
        a.innerHTML = 'SAVE CLIENT REPORT';
        a.style.backgroundColor = '#05A9B1';
        a.style.cursor = 'pointer';
        if(window.navigator.msSaveOrOpenBlob){
          a.addEventListener('click',() => window.navigator.msSaveOrOpenBlob(blob, clientName + '.pdf'));
        } else {
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = clientName + '.pdf';
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function openFPReportPDF(clientID, clientName) {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      headers: {
        Authorization: 'Token ' + getState().params.token,
      },
      url: `${getState().params.apiURL}/clients/${clientID}/report_fp/`,
      responseType: 'blob',
    };
    return axios(request)
      .then((response) => {
        const blob = new Blob([response.data], {type: 'application/pdf'});
        const a = document.getElementById('fp-report-download');
        a.innerHTML = 'SAVE ADVISOR REPORT';
        a.style.backgroundColor = '#05A9B1';
        a.style.cursor = 'pointer';
        if(window.navigator.msSaveOrOpenBlob){
          a.addEventListener('click',() => window.navigator.msSaveOrOpenBlob(blob, clientName + '-private.pdf'));
        } else {
          const url = window.URL.createObjectURL(blob);
          a.href = url;
          a.download = clientName + '-private.pdf';
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };
}

export function setSort(column) {
  return (dispatch) => {
    dispatch({ type: SET_SORT, column: column});
  };
}

export function getExcel() {
  return (dispatch) => {
    dispatch(loadClientDataExcel());
  };
}


// WEBPACK FOOTER //
// ./src/actions/advisor.js